module.exports = __webpack_public_path__ + "img/sepa_2024_10_23.91d6f1e.svg";